import { getContext } from '@fiverr-private/fiverr_context';

export const getPortfolioDateFormatter = () =>
    new Intl.DateTimeFormat(getContext().locale, {
        year: 'numeric',
        month: 'long',
    });
